import { resizeObservers } from '../ResizeObserverController';
const hasActiveObservations = () => {
    return resizeObservers.some((ro) => ro.activeTargets.length > 0);
};
export { hasActiveObservations };
